import styled from 'styled-components';
import { media } from 'utils/rwd';

export const GridArea = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ $gridColumns }) => `repeat(${$gridColumns}, 1fr)`};
  gap: 10px;
  margin-bottom: 20px;

  ${media.md`
    gap: 15px;
  `}
`;
